import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const routes = [
    {
        path: '/',
        name: 'login',
        component: () => import('../views/login/login'),
    },
]
const asyncRouters = [
    {
        path: '/Home',
        name: 'Home',
        component: () => import('../views/Home'),
        children: [
            // 首页
            {
                path: '/dataReporting/dataReporting',
                name: 'dataReporting',
                component: () => import('../views/dataReporting/dataReporting'),
            },
            // 历史数据回放
            {
                path: '/playbackData/playbackData',
                name: 'playbackData',
                component: () => import('../views/playbackData/playbackData'),
            },
            // 数据管理 --> 历史数据下载
            {
                path: '/dataManagement/downloadData',
                name: 'downloadData',
                component: () => import('../views/dataManagement/downloadData'),
            },
            // 数据管理 --> DBC文件管理
            {
                path: '/dataManagement/DBCAdministration',
                name: 'DBCAdministration',
                component: () => import('../views/dataManagement/DBCAdministration'),
            },
            // 数据管理 --> 终端轨迹查询
            {
                path: '/dataManagement/trackQuery',
                name: 'trackQuery',
                component: () => import('../views/dataManagement/trackQuery'),
            },


            // 配置管理 --> 车型管理
            {
                path: '/configurationManagement/carModelAdministration',
                name: 'carModelAdministration',
                component: () => import('../views/configurationManagement/carModelAdministration'),
            },
            // 配置管理 --> 指令配置
            {
                path: '/configurationManagement/commandConfiguration',
                name: 'commandConfiguration',
                component: () => import('../views/configurationManagement/commandConfiguration'),
            },
            // 配置管理 --> 储存信号配置
            {
                path: '/configurationManagement/signalConfiguration',
                name: 'signalConfiguration',
                component: () => import('../views/configurationManagement/signalConfiguration'),
            },
            // 配置管理 --> 试验车管理
            {
                path: '/configurationManagement/experimentCar',
                name: 'experimentCar',
                component: () => import('../views/configurationManagement/experimentCar'),
            },
            // 配置管理 --> 终端管理
            {
                path: '/configurationManagement/terminalAdministration',
                name: 'terminalAdministration',
                component: () => import('../views/configurationManagement/terminalAdministration'),
            },
            // 系统管理 --> 账号管理
            {
                path: '/system/account',
                name: 'account',
                component: () => import('../views/system/account'),
            },
            // 系统管理 --> 角色管理
            {
                path: '/system/role',
                name: 'role',
                component: () => import('../views/system/role'),
            },
            // 系统管理 --> 企业管理
            {
                path: '/system/enterprise',
                name: 'enterprise',
                component: () => import('../views/system/enterprise'),
            },
            // 系统管理 --> 菜单管理
            {
                path: '/system/menuAdministration',
                name: 'menuAdministration',
                component: () => import('../views/system/menuAdministration'),
            },
            // 系统管理 --> 日志管理
            {
                path: '/system/journal',
                name: 'journal',
                component: () => import('../views/system/journal'),
            },
            // 系统管理 --> 字典管理
            {
                path: '/system/dictionaries',
                name: 'dictionaries',
                component: () => import('../views/system/dictionaries'),
            },
        ]
    },
]
const router = new VueRouter({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes
})
// router.addRoutes(asyncRouters)
asyncRouters.forEach(res=>{
    router.addRoute(res);
})


export default router
